export enum LocalStorageKeys {
  // app state
  LAUNCH_COUNT = 'launchCount',
  NAVIGATED = 'navigated',
  LOCATION = 'location',
  DEVICEREF = 'deviceref',
  CITY = 'city',
  REGION = 'region',
  COUNTRY_CODE = 'countryCode',
  CONNECTION_BANDWIDTH = 'connectionBandwidthKbps',
  // reuse strategy
  CLEAN_ROUTES = 'cleanRoutes', //used by reuse strategy to clean routes
  CHANGED_LANGUAGE = 'changedLanguage', // used by reuse strategy to clean routes and load all again
  TAB_CHANGED = 'tabChanged', // used by reuse strategy to clean tab cache
  // lang info
  LANG = 'lang',
  WATCH_LANG = 'watch-lang',
  // user info
  USER_ID = 'userId',
  SELECTED_PROFILE = 'selectedProfile',
  SELECTED_PROFILE_ID = 'selectedProfileId',
  PROFILES = 'profiles',
  ACCOUNT_EMAIL = 'email',
  ACCOUNT_ID = 'accountAuth0Id',
  //player preferences
  SUBTITLES_LANGUAGE = 'subtitlesLanguage',
  AUDIO_LANGUAGE = 'audioLanguage',
  QUALITY_PREFERENCE = 'preferedQuality',
  AUTOPLAY_PREFERENCE = 'autoplayNext',
  // subtitles preferences
  SUBTITLES_ENABLED = 'subtitlesEnabled',
  SUBTITLES_STYLES = 'subtitles_styles',
  //tokens
  //xAuthToken: Firstlight Token
  XAUTH_TOKEN = 'xAuthToken',
  XAUTH_TOKEN_EXP = 'xAuthTokenExp',
  ID_TOKEN = 'idToken',
  AUTHDATA = 'authData',
  AUTHDATA_TOKEN_EXP = 'authDataTokenExp',

  //auth0 tokens
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  REFRESH_TOKEN_EXP = 'refreshTokenExp',
  //content
  STOREFRONTID = 'storefrontId',
  STOREFRONT_NAME = 'storefrontName',
  CONTENT_START_TIME = 'contentStartTime',
  // splash state
  SPLASH_ENDED = 'splashEnded',
  SPLASH_CLOSE_AT_THE_END = 'closeSplashAtEnd',
  // cleeng channel
  CHANNEL = 'channel',
  ACTIVE_PROFILE = 'activeProfile',
  PROFILE_TOKEN = 'profileToken',
  PROFILE_TOKEN_EXP = 'profileTokenExp',
  CLIENT_REGISTRATION = 'clientRegistration',
}
